import type { CSSProperties } from "react";

// Original high-resolution decoration, separate from game covers and identities.
// The two native-size atlases are documented in HOME_CATEGORY_ART_20260914.md.
const tiles: Record<string, [number, number]> = {
  lottery: [1, 0], slots: [2, 0], sports: [3, 0],
  fishing: [0, 1], board: [1, 1], esports: [2, 1],
};
export function CoastArt({ category, variant }: { category: string; variant?: "home" }) {
  const portrait = category === "live";
  const homePortrait = category === "live" && variant === "home";
  const [column, row] = tiles[category] ?? tiles.slots;
  const style = {
    backgroundImage: `url('/assets/west-coast/${portrait ? "portrait" : "category"}-art-hd-v1.webp')`,
    backgroundSize: portrait ? "200% auto" : "400% 200%",
    backgroundPosition: portrait ? "0 0" : `${column / 3 * 100}% ${row * 100}%`,
    aspectRatio: portrait && homePortrait ? "768 / 850" : "1",
  } satisfies CSSProperties;
  return <span className={`coast-category-art coast-category-art--${category}${homePortrait ? " coast-category-art--home-portrait" : ""}`} style={style} aria-hidden="true"/>;
}
